import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, Button, OverlayTrigger, Tooltip, Image } from '@bingads-webui-react/primitive';
import { getMenuItemStyles } from '../../../styles/menu-item-styles';
import { GetNodeClassNames } from '../../../helpers/node-helper';

const MenuItem = ({
  classes,
  node,
  renderText,
  onItemClick,
}) => {
  const cnames = classNames(
    GetNodeClassNames(node, classes),
    'main-menu-campaign-type',
    { [classes.collapsedMenuItem]: _.isNull(renderText) }
  );

  return (
    <OverlayTrigger
      key={`${node.displayName}-button-tooltip`}
      placement="right"
      delayShow={300}
      overlay={
        <Tooltip id={`${node.displayName}-tooltip-right`}>
          {node.displayName}
        </Tooltip>
        }
    >
      <Button
        key={node.id}
        className={cnames}
        btnStyle="command"
        onClick={onItemClick(node)}
        aria-label={node.displayName}
      >
        {node.isSelected && <div className={classes.beforeIcon} />}
        { !node.imageSrc &&
        <div className={classNames(classes.iconContainer, 'type-icon')}>
          <Glyphicon
            id={`${node.glyphIconName}-icon`}
            className={classNames(classes.typeSelectionIcon)}
            glyph={node.glyphIconName}
          />
        </div>
        }
        { node.imageSrc &&
        <div className={classNames(classes.iconContainer, 'type-icon')}>
          <Image
            src={node.imageSrc}
            className={classNames(classes.typeSelectionIcon)}
          />
        </div>
        }
        { renderText &&
        <span className={classNames(classes.textContainer, 'type-name')}>
          {renderText}
        </span>
        }
      </Button>
    </OverlayTrigger>
  );
};

MenuItem.defaultProps = {
  renderText: null,
};

MenuItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    glyphIconName: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    imageSrc: PropTypes.string,
    campaignType: PropTypes.oneOf(_.values(CampaignType)).isRequired,
  }).isRequired,
  renderText: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
};

export default withDefaultStyles(MenuItem, getMenuItemStyles);
